import React from 'react'
import { Ratio } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'
import styles from './index.module.css'
import { setPencilS } from '../../store/modules/pencil'
import { darkenColor } from '../../utils/publicfunction'


export default function Btnpencil() {
  const {p}=useSelector((state)=>state.pencil)
  const dispatch=useDispatch()
  const pd= p ? styles.pencildown : "";

  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);
  const darkenedColor = darkenColor(bm, 0.3);
  const buttonStyle = {
    backgroundColor: p ? darkenedColor : bm
  };

  return (
    <Ratio aspectRatio={"1x1"}>
    <div onClick={()=>dispatch(setPencilS(!p))}>
      <div
        className={`${styles.b_p_adiv} ${pd}`}
        style={buttonStyle}
      >
        <img src='./pic/pencil.svg' alt='' className={styles.b_p_img}/>
      </div>
    </div>
    </Ratio>
  )
}
